module.exports = __webpack_public_path__ + "static/media/textiles.e97e113a.jpg";